import {
  Box,
  Card,
  CardBody,
  CardHeader,
  Heading,
  Stack,
  VStack,
  Text,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react'
import React from 'react'

const EventBlueAndWhite2026: React.FC = () => (
  <Box p={4}>
    <Heading
      as='h2'
      size='lg'
      fontFamily='Cherry Swash'
      mb={4}
      color='blue.600'>
      Event Details
    </Heading>
    <VStack align='start' spacing={4} mb={8}>
      <Text>
        We are back with the third annual fundraiser! Come dressed to impress
        in blue and white on August 15, 2026 from 6:30pm-10:30pm at Triple
        Crown Country Club.
      </Text>
      <Text>
        <Text as='span' bg='yellow.200' fontWeight='bold'>
          This event is sold out!
        </Text>{' '}
        Thank you for the incredible support — we can&apos;t wait to celebrate
        with everyone who will be joining us.
      </Text>
    </VStack>
    <Heading
      as='h2'
      size='lg'
      fontFamily='Cherry Swash'
      mb={4}
      color='blue.600'>
      Event Sponsorship Levels
    </Heading>
    <Stack spacing={4}>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Shine Like a Diamond Sponsor - $3,000 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company Name/Logo on website/social media</ListItem>
            <ListItem>Logo Printed in Event Program</ListItem>
            <ListItem>Large Company Logo in slideshow</ListItem>
            <ListItem>Special recognition by emcee at event</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              6 VIP tickets + reserved table with signage
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Wildcat Sponsor - $2,000 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company Name/Logo on website/social media</ListItem>
            <ListItem>Logo Printed in Event Program</ListItem>
            <ListItem>Medium Company Logo in slideshow</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              4 VIP tickets + reserved table with signage
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Pioneer Sponsor - $1,500 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company Name on website/social media</ListItem>
            <ListItem>Name Printed in Event Program</ListItem>
            <ListItem>Small Company Name in slideshow</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              4 general event tickets + reserved table with signage
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
      <Card
        border='1px'
        borderColor='gray.200'
        borderRadius='md'
        boxShadow='sm'>
        <CardHeader>
          <Heading size='md' fontFamily='Cherry Swash' color='blue.500'>
            Thoroughbred Sponsor - $800 +
          </Heading>
        </CardHeader>
        <CardBody>
          <UnorderedList>
            <ListItem>Company Name on website/social media</ListItem>
            <ListItem>Name Printed in Event Program</ListItem>
            <ListItem>Small company name in slideshow</ListItem>
            <ListItem fontStyle='italic' fontWeight='bold'>
              2 general event tickets
            </ListItem>
          </UnorderedList>
        </CardBody>
      </Card>
    </Stack>
  </Box>
)

export default EventBlueAndWhite2026

